import { Box, Button, Dialog } from '@mui/material';
import React, { useState } from 'react';
import clsx from 'clsx';
import { ReactComponent as WarningIcon } from '../../base/images/warning.svg';
import { TaskListMobilePopupStyles } from '../styles/taskListMobilePopup';
import { useTranslation } from 'react-i18next';

const TaskListMobilePopup = (): React.JSX.Element => {
  const { classes } = TaskListMobilePopupStyles();
  const [open, setOpen] = useState<boolean>(true);
  const { t } = useTranslation();
  const clickOKButtonHandler = (): void => {
    setOpen(false);
  };

  return (
    <Dialog className={classes.dialogContainer} open={open} disableEnforceFocus>
      <Box textAlign="center" className={clsx(classes.warningIconSpecs, classes.iconColor)}>
        <WarningIcon />
      </Box>
      <Box p={`0 1.9rem 1.25rem 1.9rem`}>
        <span className={classes.assessmentColor}>
          <strong>{t('assessmentForDesktopOrMobile')}</strong>
        </span>
      </Box>
      <Box p={`0 1.9rem 1.25rem 1.9rem`}>
        <span className={classes.assessmentColor}>{t('switchToLaptopForDesktopAssessments')}</span>
      </Box>
      <Box p={`1rem`} textAlign="center">
        <Button
          variant="outlined"
          className={clsx(classes.okButton, classes.marginBottom20)}
          onClick={clickOKButtonHandler}>
          {t('ok')}
        </Button>
      </Box>
    </Dialog>
  );
};

export default TaskListMobilePopup;
